import { api, unwrap } from '../../shared/api/client';
import type { components } from '../../shared/api/schema.gen';

export type TFolder = components['schemas']['FolderResDto'];
export type TFolderScope = TFolder['scope'];
export type TFolderCrumb = components['schemas']['FolderCrumbDto'];
export type TFolderList = components['schemas']['FolderListResDto'];

export const folderKeys = {
  all: ['folders'] as const,
  list: (scope: TFolderScope) => ['folders', scope] as const,
};

export const listFolders = (scope: TFolderScope): Promise<TFolderList> =>
  unwrap(api.GET('/v1/folders', { params: { query: { scope } } }));

export const createFolder = (body: {
  scope: TFolderScope;
  name: string;
  parentId: string | null;
}): Promise<TFolder> => unwrap(api.POST('/v1/folders', { body }));

export const renameFolder = (id: string, name: string): Promise<TFolder> =>
  unwrap(api.PATCH('/v1/folders/{id}', { params: { path: { id } }, body: { name } }));

export const moveFolder = (id: string, parentId: string | null): Promise<TFolder> =>
  unwrap(api.POST('/v1/folders/{id}/move', { params: { path: { id } }, body: { parentId } }));

export const deleteFolder = (id: string, moveContentsUp: boolean): Promise<void> =>
  unwrap(
    api.DELETE('/v1/folders/{id}', {
      params: { path: { id }, query: moveContentsUp ? { moveContentsTo: 'parent' } : {} },
    }),
  ).then(() => undefined);

export const moveItems = (
  scope: TFolderScope,
  ids: readonly string[],
  folderId: string | null,
): Promise<number> =>
  unwrap(api.POST('/v1/folders/move-items', { body: { scope, ids: [...ids], folderId } })).then(
    (result) => result.moved,
  );
